import { Center, Text } from '@chakra-ui/react'

export const InvoiceDetailsEmpty = () => (
  <Center px="40px" py="20px" borderRadius="4px" borderWidth="1px" borderColor="dark.300" h="300px">
    <Text>Não há boletos disponíveis no momento.</Text>
  </Center>
)
